<template>
  <v-app v-if="this.auth == 1" id="inspire">
    <v-dialog persistent v-model="altpwd" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Alterar password</span>
        </v-card-title>
        <v-form ref="form">
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <label class="label-modal">Password</label>
                  <v-text-field
                    color="#f8ac4a"
                    type="password"
                    v-model="pwd"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <label class="label-modal">Confirmar password</label>
                  <v-text-field
                    color="#f8ac4a"
                    type="password"
                    v-model="cpwd"
                    :rules="pwdRules"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#f8ac4a" flat @click.native="altpwd = false"
              >Cancelar</v-btn
            >
            <v-btn color="#f8ac4a" flat @click.native="changeData"
              >Guardar</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="excel" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Exportar excel</span>
        </v-card-title>
        <v-form ref="form">
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex v-if="getSession.user.super" xs12 sm12 md12>
                  <label class="label-modal">Instituição</label>
                  <v-autocomplete
                    color="#f8ac4a"
                    :items="[
                      { id_instituicao: 0, nome: 'TODAS' },
                      ...getAllInstituicoes,
                    ]"
                    v-model="INSTITUICAO"
                    item-text="nome"
                    item-value="id_instituicao"
                  ></v-autocomplete>
                  <span style="font-size: 12px; color: grey;"
                    >* a opção TODAS poderá demorar alguns minutos</span
                  >
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <label class="label-modal">Ano</label>
                  <v-autocomplete
                    color="#f8ac4a"
                    :items="getAnos"
                    v-model="ANO"
                    item-text="nome"
                    item-value="nome"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#f8ac4a" flat @click.native="excel = false"
              >Cancelar</v-btn
            >
            <v-btn color="#f8ac4a" flat @click.native="exportar"
              >Exportar</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-navigation-drawer
      :clipped="$vuetify.breakpoint.lgAndUp"
      v-model="drawer"
      fixed
      app
    >
      <v-list dense>
        <template v-for="(item, index) in items">
          <v-list-tile
            v-if="
              item.super == 0 || (item.super == 1 && getSession.user.super == 1)
            "
            :key="index"
            :to="item.to"
          >
            <v-list-tile-action class="pm-text">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="pm-text">
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      color="#f8ac4a"
      dark
      app
      fixed
    >
      <v-toolbar-title style="width: 600px" class="ml-0 pl-3">
        <v-toolbar-side-icon
          @click.stop="drawer = !drawer"
        ></v-toolbar-side-icon>
        <span class="hidden-sm-and-down">ENED</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <span class="wlcTxt">Bem-vindo, {{ getSession.user.nome }}</span>
      <span class="divi">|</span>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" v-on:click.stop="altpwd = true" icon>
            <v-icon>settings</v-icon>
          </v-btn>
        </template>
        <span>Alterar password</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" v-on:click.stop="excel = true" icon>
            <v-icon>grid_on</v-icon>
          </v-btn>
        </template>
        <span>Exportar excel</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" v-on:click.stop="logout" icon>
            <v-icon>power_settings_new</v-icon>
          </v-btn>
        </template>
        <span>Sair</span>
      </v-tooltip>
    </v-toolbar>
    <v-content>
      <v-container fluid fill-height>
        <v-layout> <router-view></router-view> </v-layout>
      </v-container>
    </v-content>
  </v-app>
  <Login v-else-if="this.auth == 0" />
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import JWT from "jsonwebtoken";

export default {
  data: () => ({
    auth: -1,
    drawer: null,
    items: [
      {
        icon: "home",
        super: 0,
        text: "Home",
        to: "/",
      },
      {
        icon: "done_all",
        super: 0,
        text: "Propostas",
        to: "/propostas",
      },
      {
        icon: "account_circle",
        super: 0,
        text: "Perfil",
        to: "/perfil",
      },
      {
        icon: "class",
        super: 1,
        text: "Formulários",
        to: "/formularios",
      },
      {
        icon: "question_answer",
        super: 1,
        text: "Perguntas",
        to: "/perguntas",
      },
      {
        icon: "view_carousel",
        super: 1,
        text: "Dimensões",
        to: "/dimensoes",
      },
      {
        icon: "view_list",
        super: 1,
        text: "Objetivos",
        to: "/objetivos",
      },
      {
        icon: "vertical_split",
        super: 1,
        text: "Medidas",
        to: "/medidas",
      },
      {
        icon: "view_module",
        super: 1,
        text: "Ações",
        to: "/acoes",
      },
      {
        icon: "list",
        super: 1,
        text: "Setores",
        to: "/setores",
      },
      {
        icon: "date_range",
        super: 1,
        text: "Fases",
        to: "/anos",
      },
      {
        icon: "people",
        super: 1,
        text: "Administradores",
        to: "/administradores",
      },
      {
        icon: "domain",
        super: 1,
        text: "Instituições",
        to: "/instituicoes",
      },
    ],
    altpwd: false,
    excel: false,
    ANO: null,
    INSTITUICAO: null,
    email: "",
    pwd: "",
    cpwd: "",
    defaultRules: null,
    pwdRules: null,
  }),
  computed: {
    ...mapGetters({
      getSession: "session/getState",
      getAnos: "anos/getAll",
      getAllInstituicoes: "instituicoes/getAllInstituicoes",
    }),
  },
  watch: {
    excel(val) {
      if (!val) {
        setTimeout(() => {
          this.ANO = null;
          this.INSTITUICAO = null;
        }, 150);
      }
    },
    altpwd(val) {
      this.pwd = "";
      this.cpwd = "";
    },
  },
  created() {
    this.pwdRules = [
      (v) => v == this.pwd || "* As palavras-passe não coincidem!",
    ];

    this.ManageSession();

    this.$eventBus.$on("login", (res) => {
      if (res) {
        this.SessionStart();
      }
    });

    this.$eventBus.$on("logout", () => {
      this.logout();
    });
  },
  methods: {
    changeData() {
      if (this.pwd && this.pwd == this.cpwd)
        this.$store
          .dispatch("session/update", {
            id: this.getSession.user.id_instituicao,
            password: this.pwd,
          })
          .then((res) => {
            if (res) {
              this.toast("success", "Password alterada com sucesso!");
              this.altpwd = false;
            } else {
              this.toast("error", "Ocorreu um erro ao alterar a password!");
              this.altpwd = false;
            }
          });
    },
    toast(type, message) {
      if (type == "success") {
        return iziToast.show({
          title: "SUCESSO",
          color: "green",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition,
        });
      } else {
        return iziToast.show({
          title: "ERRO",
          color: "red",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition,
        });
      }
    },

    exportar() {
      if (this.ANO == null) return;
      if (this.getSession.user.super == 1 && this.INSTITUICAO == null) return;

      if (this.getSession.user.super == 1) {
        window.open(
          process.env.API_IP +
            ":" +
            process.env.API_PORT +
            "/enedapi/client/excel/" +
            this.ANO +
            "/" +
            this.INSTITUICAO,
          "_blank"
        );
      } else {
        window.open(
          process.env.API_IP +
            ":" +
            process.env.API_PORT +
            "/enedapi/client/excel/" +
            this.ANO +
            "/" +
            this.getSession.user.id_instituicao,

          "_blank"
        );
      }

      this.excel = false;
    },

    ManageSession() {
      if (!this.$session.exists()) this.auth = 0;
      else {
        this.decode(this.$session.getAll().t).then((res) => {
          this.$store
            .dispatch("session/getData", {
              username: res,
            })
            .then(() => {
              if (this.getSession.session) {
                this.SessionStart();
              } else this.auth = 0;
            });
        });
      }
    },

    SessionStart() {
      this.$session.start();
      this.$session.set("t", this.token(this.getSession.user.username));
      this.OpenStore();
    },
    async OpenStore() {
      this.$store.dispatch("instituicoes/get");
      this.$store.dispatch("objetivos/get");
      this.$store.dispatch("medidas/get");
      this.$store.dispatch("acoes/get");
      this.$store.dispatch("fases/get");
      this.$store.dispatch("dimensoes/get");
      this.$store.dispatch("perguntas/get");
      this.$store.dispatch("formularios/get");
      this.$store.dispatch("setores/get");
      this.$store.dispatch("anos/get");
      if (this.getSession.user.super == 0)
        this.$store.dispatch(
          "propostas/getByInstituicao",
          this.getSession.user.id_instituicao
        );
      if (this.getSession.user.super == 1)
        this.$store.dispatch("propostas/get");

      this.auth = 1;

      this.$eventBus.$emit("loader", false);
    },
    logout() {
      this.$store.dispatch("session/setSessionData", null).then(() => {
        this.auth = 0;
        this.$session.destroy();
        setTimeout(() => location.reload(true), 600);
      });
    },
    token(params) {
      return JWT.sign(
        {
          exp: Math.floor(Date.now() / 1000) + 60 * 60 * 12,
          data: params,
        },
        process.env.SECRET
      );
    },
    decode(token) {
      return new Promise(function(resolve, reject) {
        JWT.verify(token, process.env.SECRET, (err, decoded) => {
          if (err) resolve(false);
          else resolve(JWT.decode(token).data);
        });
      });
    },
  },
};
</script>

<style>
.application {
  font-family: "Ubuntu", sans-serif !important;
}

.theme--light.application {
  background: #f8f8f8 !important;
}

.container {
  margin: 0 !important;
}

.pm-text {
  color: #5d5d5d !important;
}

.v-list__tile--active > div {
  color: #f8ac4a !important;
}

.v-table .error {
  background-color: white !important;
  color: rgba(0, 0, 0, 0.3) !important;
}

.searchTable {
  width: 25% !important;
  float: right !important;
  padding-bottom: 10px !important;
  margin-right: 10px !important;
}

.v-table tr {
  cursor: pointer !important;
}

.theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
  background-color: #eee !important;
}

.tableHeader {
  padding: 10px !important;
  background-color: white !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
}

.textTable {
  justify-content: center !important;
}

.textLeft {
  text-align: left !important;
}

.textCenter {
  text-align: center !important;
}

.label-modal {
  font-size: 11px !important;
  color: #c4c4c4 !important;
  text-transform: uppercase !important;
}

.theme--light.v-subheader {
  color: #f8ac4a !important;
}

.v-subheader--inset {
  margin: 0 !important;
}

.v-subheader {
  padding: 0 !important;
}

.iziToast-wrapper-topRight {
  margin-top: 50px !important;
}

.v-tabs__slider-wrapper {
  height: 10px !important;
  width: 146px !important;
}

.v-card__actions {
  margin-top: -40px !important;
}

.noTableHeader {
  background-color: #fff !important;
  height: 58px !important;
}

.tableTitle {
  position: absolute;
  margin: 25px;
  color: #f8ac4a;
  font-size: 19px;
  font-weight: 400;
}

.settings-switch {
  flex: none !important;
}

.divi {
  font-size: 25px !important;
  font-weight: 400 !important;
  margin-right: 10px !important;
}

.headline {
  margin-left: 20px !important;
  margin-bottom: -30px !important;
  color: #f8ac4a !important;
}

.deleteModal {
  margin-left: 0px !important;
}

.actions-delete {
  margin-top: 0px !important;
}

.menu-ativo div,
.menu-ativo i {
  color: #f8ac4a !important;
  caret-color: #f8ac4a !important;
}

.v-btn-toggle--selected {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.1), 0 2px 2px 0 rgba(0, 0, 0, 0.05),
    0 1px 5px 0 rgba(0, 0, 0, 0) !important;
}

.wlcTxt {
  font-size: 15px !important;
  margin-right: 25px !important;
  text-transform: uppercase !important;
}

.formulario .v-input--selection-controls {
  margin-top: 0px !important;
}

.formulario .v-input__slot {
  margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue